function readBlobText(blob) {
  if (blob && typeof blob.text === 'function') return blob.text()
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(String(reader.result || ''))
    reader.onerror = () => reject(reader.error || new Error('文件读取失败'))
    reader.readAsText(blob)
  })
}

function responseFileName(response, fallbackName) {
  const disposition = response && response.headers && response.headers['content-disposition']
  if (!disposition) return fallbackName
  const utf8Name = disposition.match(/filename\*=UTF-8''([^;]+)/i)
  if (utf8Name) {
    try { return decodeURIComponent(utf8Name[1]) } catch (error) { return fallbackName }
  }
  const plainName = disposition.match(/filename="?([^";]+)"?/i)
  return plainName ? plainName[1] : fallbackName
}

export async function downloadBlobResponse(response, fallbackName) {
  const blob = response && response.data
  if (!(blob instanceof Blob)) throw new Error('合同文件返回格式异常')
  if ((blob.type || '').toLowerCase().indexOf('json') >= 0) {
    const body = JSON.parse(await readBlobText(blob))
    throw new Error(body.msg || '合同生成失败')
  }
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = responseFileName(response, fallbackName)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
